import { Text } from '@vtex/admin-ui'
import { FormattedList } from 'react-intl'
import { NumberInput } from '../../../../../NumberInput'
import { FormState } from '@vtex/admin-ui-form'
import { styles } from './styles'

type Props = {
  name: string
  form: FormState
  type: 'conjunction' | 'disjunction'
}

export function RangeInput(props: Props) {
  const { name, form, type } = props

  return (
    <Text tone="secondary" className={styles.range}>
      <FormattedList
        type={type}
        value={[
          <NumberInput
            name={`${name}.min`}
            state={form}
            fractionDigits={0}
            key="min"
          />,
          <NumberInput
            name={`${name}.max`}
            state={form}
            fractionDigits={0}
            key="max"
          />,
        ]}
      />
    </Text>
  )
}
